import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './App.css';
import LoginForm from './LoginForm.js';
import RegistrationForm from './Registration/RegistrationForm.js';
import AssignCertificationForm from './Registration/AssignCertificationForm.js';
import { Menu, LocaleProvider, Card, Icon, Layout, Breadcrumb } from 'antd';
import registerServiceWorker from './registerServiceWorker';
import Admin from './Admin/Admin.js';

import EscView from './CourseViews/Esc.js';
import TcpView from './CourseViews/Tcp.js';
import CRView from './CourseViews/CivilRights';

import AddClassForm from './Admin/AddClassForm';
import EditClassForm from './Admin/EditClasses';
import GradeClassForm from './Admin/GradeClass';

import MultipleStudentRegistration from './Registration/MultiStudentRegistration';
import RegisterAttendee from './Registration/RegistrationForm';
import AssignCertification from './Registration/AssignCertificationForm';
import EditAttendee from './Admin/EditStudent';
import EmailEditor from './Admin/EmailEditor';
import ChangeClasses from './Admin/ChangeClasses';
import Payment from './Admin/StudentPayment';
import AddEmployerForm from './Admin/AddEmployerForm';
import StudentHistory from './Admin/SearchStudentHistory';
import MergeStudents from './Admin/MergeStudents';
import SearchStudent from './Registration/SearchStudent';
import AddESCC from './Admin/AddESCC';
import AssignESCC from './Admin/AssignESCC';
import ImportForm from './Admin/ImportStudents';
import Home from './Breadcrumbs';
import AssignECRT from './Admin/AssignECRT';
import AddECRT from './Admin/AddECRT';

import config from './config';
import $, { unique } from 'jquery';

//import Rythm from 'rythm.js'
import Test from './Test.js';

import enUS from 'antd/lib/locale-provider/en_US';
import {
    BrowserRouter as Router, HashRouter,
    Route, Link, Redirect
} from 'react-router-dom';
const { Content, Sider } = Layout;
const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            adminActive: false,
            title: 'Register',
            activeTab: 1,
            headerHTML: '',
            footerHTML: '',
            headHTML: '',
            dataReceived: false,
        };
        if (window.location.href.includes("Multiple")) {
            this.state.activeTab = 2;
        } else if (window.location.href.includes("CRregistry")) {
            this.state.activeTab = 4;
        } else if (window.location.href.includes("register")) {
            this.state.activeTab = 1;
        } else if (window.location.href.includes("registry")) {
            this.state.activeTab = 3;
        } else {
            this.state.activeTab = 0;
        }
        this.setupHeader();
    }

    setupHeader = () => {

        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/Wrapper/wrapperHeader`,
        })
            .done((data) => {
                const dataArray = data.split("~~~")
                this.setState({ headerHTML: dataArray[1], footerHTML: dataArray[2], headHTML: dataArray[0], dataReceived: true })

                console.log(data)
            })
            .fail((jqXhr) => {
                console.log('failed to get employer');
            });
    }
    componentWillReceiveProps(nextProps) {
        console.log(window.location.href);
    }



    render() {
        const showAdminMenu = () => {
            this.setState({ adminActive: true });
        };
        if (this.state.dataReceived) {
            return (
                <div>

                    <HashRouter basename="/">
                        <div>
                            <div>
                                <div dangerouslySetInnerHTML={{ __html: this.state.headHTML + this.state.headerHTML }}></div>
                                <div role="main" class="main-container container js-quickedit-main-content">
                                    <div class="row">
                                        <section class="col-sm-12"></section>
                                        <header style={{ margin: "auto" }}>
                                            <nav className="navbar navbar-default margin-bottom-0" id="certNav" role="navigation">
                                                <div className="container">
                                                    {/*The route url are defined here.*/}
                                                    {!this.state.adminActive && <div style={{ width: '100%', backgroundColor: '#0e406a' }}>
                                                        <ul className="nav navbar-nav list-group-horizontal">
                                                            <li className={(this.state.activeTab == 1) ? "activeNav" : "inactiveNav"}>
                                                                <Link to="/register" style={{ color: 'white' }} onClick={() => {
                                                                    this.setState({
                                                                        activeTab: 1
                                                                    });
                                                                }}>Register Student</Link>
                                                            </li>
                                                            <li className={(this.state.activeTab == 2) ? "activeNav" : "inactiveNav"}>
                                                                <Link to="/registerMultiple" style={{ color: 'white' }} onClick={() => {
                                                                    this.setState({
                                                                        activeTab: 2
                                                                    });
                                                                }}>Register Multiple Students</Link>
                                                            </li>
                                                            {/* <li className="pull-left rythm-high">
                                                    <Link to="/searchStudent">Search Student</Link>
                                                </li> */}
                                                            {//<li className="nav-no-link pull-left">|</li>
                                                                <li className={(this.state.activeTab == 3) ? "activeNav" : "inactiveNav"}>
                                                                    <Link to="/registry" style={{ color: 'white' }} onClick={() => {
                                                                        this.setState({
                                                                            activeTab: 3
                                                                        });
                                                                    }}>Print Certification</Link>
                                                                </li>
                                                            }
                                                            {//<li className="nav-no-link pull-left">|</li>
                                                                <li className={(this.state.activeTab == 4) ? "activeNav" : "inactiveNav"}>
                                                                    <Link to="/CRregistry" style={{ color: 'white' }} onClick={() => {
                                                                        this.setState({
                                                                            activeTab: 4
                                                                        });
                                                                    }}>Print Civil Rights Attendance Certificate</Link>
                                                                </li>
                                                            }
                                                        </ul>

                                                        <ul className="nav navbar-nav pull-right list-group-horizontal">
                                                            <li className={(this.state.activeTab == 0) ? "activeNav" : "inactiveNav"}>
                                                                <Link style={{ color: 'white' }} onClick={() => {
                                                                    this.setState({
                                                                        adminActive: false,
                                                                        title: 'Admin',
                                                                        activeTab: 0
                                                                    });
                                                                }} to="/login">Admin</Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    }
                                                    {this.state.adminActive &&
                                                        <div style={{ width: "100%", backgroundColor: "#0e406a" }}>
                                                            <Home />

                                                            <ul className="nav navbar-nav pull-right list-group-horizontal">
                                                                <li className="inactiveNav" style={{ float: 'right', paddingLeft: '10px', paddingRight: '10px', color: 'white', lineHeight: '51px' }}>Username: {LoginForm.getUsername()} </li>
                                                                <li className="inactiveNav" style={{ float: 'right', height: '51px' }}>
                                                                    <Link style={{ color: 'white' }} onClick={() => {
                                                                        this.setState({
                                                                            adminActive: false,
                                                                            title: 'Admin'
                                                                        });
                                                                        if (LoginForm.getTimeout()) { clearInterval(LoginForm.getTimeout()) };
                                                                        window.location.reload();
                                                                    }} to="">Logout</Link>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    }
                                                </div>
                                            </nav>
                                        </header>

                                        <div className="container-fluid maincontent" role="main" style={{ padding: 20, margin: 'auto' }}>
                                            <LocaleProvider locale={enUS}>
                                                {/*The routes are defined in this block*/}
                                                <Content style={{ padding: '0 24px', minHeight: 280, width: '100%' }}>
                                                    <Route path="/login" breadcrumbName="Login" render={() => <LoginForm onLogin={showAdminMenu} />} />
                                                    <Route path="/register" breadcrumbName="Register" component={RegistrationForm} />
                                                    <Route path="/tcp" breadcrumbName="Home" component={TcpView} />
                                                    <Route path="/registry" breadcrumbName="Home" component={EscView} />
                                                    <Route path="/CRregistry" breadcrumbName="Home" component={CRView} />
                                                    <Route path="/searchStudent" breadcrumbName="Search Student" component={SearchStudent} />
                                                    <Route path="/registerMultiple" breadcrumbName="Home" component={MultipleStudentRegistration} />
                                                    <Route path="/admin/admin" breadcrumbName="Main Menu" component={Admin} />
                                                    <Route path="/admin/add" breadcrumbName="Add Class" component={AddClassForm} />
                                                    <Route path="/admin/editclass" breadcrumbName="Edit Class" component={EditClassForm} />
                                                    <Route path="/admin/grade" breadcrumbName="Home" component={GradeClassForm} />
                                                    <Route path="/admin/register" breadcrumbName="Home" component={RegisterAttendee} />
                                                    <Route path="/admin/assigncert" breadcrumbName="AssignCert" component={AssignCertificationForm} />
                                                    <Route path="/admin/editattendee" breadcrumbName="Home" component={EditAttendee} />
                                                    <Route path="/admin/email" breadcrumbName="Home" component={EmailEditor} />
                                                    <Route path="/admin/change" breadcrumbName="Home" component={ChangeClasses} />
                                                    <Route path="/admin/payment" breadcrumbName="Home" component={Payment} />
                                                    <Route path="/admin/import" breadcrumbName="Import Students" component={ImportForm} />
                                                    <Route path="/admin/addemployer" breadcrumbName="Home" component={AddEmployerForm} />
                                                    <Route path="/admin/searchStudentHistory" breadcrumbName="Search Student History" component={StudentHistory} />
                                                    <Route path="/admin/merge" breadcrumbName="Merge" component={MergeStudents} />
                                                    <Route path="/test" breadcrumbName="Home" component={Test} />
                                                    <Route path="/admin/addescc" breadcrumbName="AddESCC" component={AddESCC} />
                                                    <Route path="/admin/assignescc" breadcrumbName="AssignESCC" component={AssignESCC} />
                                                    <Route path="/admin/addecrt" breadcrumbName="AddECRT" component={AddECRT} />
                                                    <Route path="/admin/assignecrt" breadcrumbName="AssignECRT" component={AssignECRT} />
                                                    <Route path="/admin/registerMultiple" breadcrumbName="Home" component={MultipleStudentRegistration} />
                                                </Content>
                                            </LocaleProvider>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </HashRouter >
                    <div dangerouslySetInnerHTML={{ __html: this.state.footerHTML }}></div>
                </div >

            );
        } else {
            return (
                <div></div>
            );
        }

    }


}


ReactDOM.render(
    <App />
    , document.getElementById('root'));


registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js